module.exports = __webpack_public_path__ + "img/saveBtnHover.4bff2462.png";